import {form_params} from 'utils/form_utils'
import {GeneratorTab} from 'generator/generator_tab'

export class PortfolioForm extends GeneratorTab

  portfolioFormParameters: ->
    params = form_params('form.portfolio-form')
    params.append 'portfolio[currency_id]', @currency.value
    params